import { cn } from '../../lib/utils';
import * as React from 'react';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: 'default' | 'secondary' | 'outline';
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
    return (
        <div
            className={cn(
                'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
                variant === 'default' && 'bg-primary text-primary-foreground',
                variant === 'secondary' && 'bg-muted text-foreground',
                variant === 'outline' && 'text-foreground',
                className
            )}
            {...props}
        />
    );
}



